/**
 * Role / identity helpers for CMS screens.
 *
 * Several lists are scoped per internal user (Lead Inbox, Demo Bookings, …):
 * a normal admin sees only what is assigned to them, a super-admin sees
 * everything. Keeping that rule in one place so the screens can't drift apart.
 */

// The role string is stored at login as user.role — casing/format varies by
// environment, so normalize before comparing.
export const currentRole = () =>
  (localStorage.getItem("trade_user_type") || "").toLowerCase().trim();

export const isSuperAdmin = () => {
  const role = currentRole();
  return role === "super-admin" || role === "super_admin" || role === "superadmin";
};

export const isAdmin = () => currentRole() === "admin";

/**
 * Who may see every lead instead of only their own reporting line.
 *
 * Super-admin alone. An admin is a reporting node like anyone else: their Inbox
 * shows their own leads plus their team's (see useMyTeam), not the whole
 * pipeline. They still keep the manage rights below.
 */
export const canViewAllLeads = () => isSuperAdmin();

export const isManager = () => currentRole() === "manager";

/**
 * Who may move a lead from one internal user to another.
 * Only super-admin, admin and manager — an executive works their own queue and
 * must not be able to hand leads off.
 */
export const canTransferLeads = () => isSuperAdmin() || isAdmin() || isManager();

/** Logged-in internal user id (number), or "" when not available. */
export const currentUserId = () =>
  Number(localStorage.getItem("trade_user_id")) || "";
